import { Iterable, OrderedMap } from 'immutable';
import invariant from 'react-utils/invariant';
// @ts-expect-error ts-migrate
import { getId } from '../../common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error ts-migrate
import { buildMessageFromType } from './buildMessageFromType';
/**
 * Construct an OrderedMap<string, MessageRecord> from an iterable of MessageRecords
 *
 * @param {OrderedMap<string, MessageRecord> | MessageRecord[]} messages Message objects returned by the history API
 */
export const buildOrderedMessageMap = (messages = OrderedMap()) => {
  invariant(Iterable.isIterable(messages) || Array.isArray(messages), 'Expected messages to be iterable not a `%s`', typeof messages);
  return messages.reduce((acc, messageObject) => {
    const message = buildMessageFromType(messageObject);
    const key = getId(message);
    return acc.set(key, message);
  }, OrderedMap());
};